import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import s from './Navigation.module.scss';

type ScreenSizeWrapperProps = {
  screenSizeWrapper: 'm' | 'mDown';
  children: ReactNode;
};

const ScreenSizeWrapper: FC<ScreenSizeWrapperProps> = ({ screenSizeWrapper, children }) => (
  <div className={getClassName(s, 'screenSizeWrapper', classNames({ [screenSizeWrapper]: true }))}>
    {children}
  </div>
);

export default ScreenSizeWrapper;
